'use client';

import type { JobTemplate } from '@repo/api-gw-sdk';
import { useCallback } from 'react';

import { DeleteEntityDialog } from '@/components/lakehouse/deleteEntityDialog';
import { useDAL } from '@/contexts/useDAL';

interface DeleteJobTemplateDialogProps {
  template: JobTemplate;
  workspaceId: string;
  open: boolean;
  onClose: () => void;
  onDeleted: () => void;
}

export const DeleteJobTemplateDialog = ({
  template,
  workspaceId,
  open,
  onClose,
  onDeleted,
}: DeleteJobTemplateDialogProps) => {
  const dal = useDAL();

  const handleDelete = useCallback(async () => {
    await dal.lakehouse.deleteJobTemplate(workspaceId, template.id);
    onDeleted();
  }, [dal, workspaceId, template.id, onDeleted]);

  return (
    <DeleteEntityDialog
      open={open}
      title='Delete Job Template'
      entityLabel='job template'
      entityName={template.name}
      warning='This action cannot be undone. Any references to this template will no longer work.'
      onClose={onClose}
      onDelete={handleDelete}
      testIdPrefix='delete-job-template'
    />
  );
};
